import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=21236260&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=21236260&prod&scoped=true&lang=css"
import style1 from "./Drawer.vue?vue&type=style&index=1&id=21236260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21236260",
  null
  
)

export default component.exports